export default __webpack_public_path__ + "static/media/home-consulting-tab-img-04.7c556694.jpg";